// extracted by mini-css-extract-plugin
export var actionIcon = "_nt-0";